export default __webpack_public_path__ + "static/media/GEM_Logo.fd2ac448.svg";